<template>
  <div class="mask" @click="isShow = false" v-if="isShow">
    <div class="popup-section" :style="{ left: offsetLeft + 'px' }" @click.stop>
      <div class="title">{{ $t("我的私信") }}</div>
      <ul class="info-ul">
        <li
          class="info-li"
          v-for="(item, index) in info"
          :key="index"
          @click="chat(item)"
        >
          <img :src="item.to_head_img" class="head-img" />
          <div class="right">
            <div class="info">
              <span class="name">{{ item.to_user_nickname }}</span>
              <span class="date">{{ item.create_time }}</span>
            </div>
            <div class="content" v-if="item.new.type == 'txt'">
              {{ item.new.content }}
            </div>
            <div class="content" v-if="item.new.type == 'img'">{{ $t("图片") }}</div>
          </div>
        </li>
      </ul>
      <div class="bottom pointer" @click="toAll">{{ $t("查看全部私信") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 距离左边距离
    left: {
      type: [String, Number],
      default: 0,
    },
    info: {
      type: [Object, Array],
      default: 0,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    offsetLeft() {
      return this.left - 155;
    },
  },
  methods: {
    hidden() {
      this.isShow = false;
    },
    chat(item) {
      let data = {
        friend_img: item.to_head_img,
        friend_name: item.to_user_nickname,
        friend_id: "hafa" + item.to_user_id,
      };
      this.$emit("chat", data);
      this.isShow = false;
    },
    toAll() {
      this.chat(this.info[0]);
      this.isShow = false;
    },
    show() {
      this.isShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "themePath/notice";
</style>



// WEBPACK FOOTER //
// src/components/privateLetter.vue